'use client'

// src/chevron/ChevronIcon.tsx
import { jsx } from "react/jsx-runtime";
var ChevronIcon = ({ className = "" }) => {
  return /* @__PURE__ */ jsx(
    "svg",
    {
      width: "8",
      height: "12",
      viewBox: "0 0 8 12",
      fill: "none",
      className,
      xmlns: "http://www.w3.org/2000/svg",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M0.910906 1.58909C0.585469 1.26366 0.585469 0.736019 0.910906 0.410582C1.23634 0.0851447 1.76398 0.0851447 2.08942 0.410582L7.08942 5.41058C7.4049 5.72606 7.41594 6.23405 7.11446 6.56294L2.53112 11.5629C2.22013 11.9022 1.69299 11.9251 1.35372 11.6141C1.01446 11.3031 0.99154 10.776 1.30253 10.4367L5.34671 6.0249L0.910906 1.58909Z",
          fill: "currentColor"
        }
      )
    }
  );
};

export {
  ChevronIcon
};
//# sourceMappingURL=chunk-F5NAH526.mjs.map